import { render, staticRenderFns } from "./MenuSec.vue?vue&type=template&id=dba15b2c&scoped=true&"
import script from "./MenuSec.vue?vue&type=script&lang=js&"
export * from "./MenuSec.vue?vue&type=script&lang=js&"
import style0 from "./MenuSec.vue?vue&type=style&index=0&id=dba15b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba15b2c",
  null
  
)

export default component.exports